import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Deleteicon from "../../static/svg/Deleteicon";

interface Agent {
  id: string | number;
  name: string;
}

interface SortableAgentProps {
  agent: Agent;
  // onRemove: () => void;
}

export const SortableAgent: React.FC<SortableAgentProps> = ({ agent }) => {
  const {
    attributes, // Attributes needed for the sortable item
    listeners, // Listeners to handle drag events
    setNodeRef, // Ref to attach to the sortable item
    transform, // Transform styles (for dragging)
    transition, // Transition styles (for smooth dragging)
  } = useSortable({ id: agent.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="p-3 mb-2 bg-white border rounded d-flex justify-content-between align-items-center"
      {...attributes}
      {...listeners}
    >
      <span>{agent.name}</span>
    </div>
  );
};